import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getProviderCompaniesListFetchSuccess, getProviderCompaniesListFetchFailure } from './reducer';
import { ProviderCompaniesListResType } from 'src/types/providerCompaniesList';

const getProviderCompaniesListFetchRequest = async () => {
    const res = await api('get', 'api/secure/provider-companies');
    return res.data.data;
};

function* getProviderCompaniesListFetch() {
    try {
        const response: ProviderCompaniesListResType = yield call((): any => getProviderCompaniesListFetchRequest());
        yield put(getProviderCompaniesListFetchSuccess(response));
    } catch (error) {
        yield put(getProviderCompaniesListFetchFailure({ error }));
    }
}

export function* getProviderCompaniesListFetchWatch() {
    yield takeEvery('providerCompaniesList/getProviderCompaniesListFetch', getProviderCompaniesListFetch);
}
